// Used for text-to-motion batch generation (e.g. Motion generation applet)
import { FrameRate, RotationOffsets } from '../types';
import apiRequest from './apiRequest';

export type Axis = 'X' | 'Y' | 'Z' | '-X' | '-Y' | '-Z';

export type ExportType =
  | 'bvh'
  | 'fbx-blender'
  | 'fbx-maya'
  | 'fbx-unreal'
  | 'fbx-roblox'
  | 'glb'
  | 'ma'
  | 'mb';

export type KeyframeCleaningMethod = 'none' | 'reduce' | 'simplify';

export type ExportSettings = {
  characterID: string;
  exportType: ExportType;
  forward: Axis;
  frameRate: FrameRate;
  frameStepSize: number;
  moveInPlace: boolean;
  up: Axis;
  faceExpression?: string;
  handPose?: string;
  ikFeet?: boolean;
  ikHands?: boolean;
  includeMesh?: boolean;
  keyframeCleaning?: KeyframeCleaningMethod;
  rotationOffsets?: RotationOffsets;
  skinHex?: string;
};

export type SwingProperties = {
  cfgScale?: number;
  duration?: number;
};

type MotionFromTextPayload = {
  batchName?: string;
  createdByUser?: string;
  exportSettings: ExportSettings;
  prompts: string[];
  loop?: boolean;
  requestedModel: 'scoot' | 'swing';
  swingProperties?: SwingProperties;
  subscribers?: string[];
};

type MotionFromTextResponse = {
  batchID: string;
  status: 'VALIDATING' | 'IN_PROGRESS' | 'COMPLETED' | 'REJECTED' | 'FAILED' | 'CANCELLED';
  type: 'GENERATION';
  emailSubscribers: string[];
  exportSettings: ExportSettings;
  numTotalJobs: number;
  estimatedSecondsWaitTime: number;
  createdAt: string;
  createdBy: string;
};

export default async function postMotionFromText(
  payload: MotionFromTextPayload,
  apiKey: string,
) {
  return await apiRequest<MotionFromTextResponse>(
    'external-mogen',
    '/motion/fromText',
    {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
